
import { getData, postData } from '../utils/api-service';
import { GET_SET_REVIEWS } from '../utils/api';
import WashdayClientSingleton from './WashdayClientSingleton';

interface CustomerStoreReviewForm {
  comment: string
  store: string
  date: Date
  rate: number
  customer: string,
}

export const submitCustomerStoreReview = async (storeId: string, data: CustomerStoreReviewForm) => {
  try {
    const res = await postData(`${GET_SET_REVIEWS}/${storeId}`, data);
    return !!res;
  } catch (e) {
    throw e;
  }
};

export const getReviewStoreInfo = async (storeId: string) => {
  try {
    const res = await getData(`${GET_SET_REVIEWS}/store/${storeId}`);
    if (!res || !res?.data?.data) {
      throw 'No se ha enviado email de verificacion';
    }
    return res?.data?.data;
  } catch (e) {
    console.log('Error al enviar, contacte a soporte tecnico');
    throw e;
  }
};

export const requestStoreReviewByCustomerIdV2 = async (storeId: string, customerId: any) => {
  try {
    return await WashdayClientSingleton.getInstance().review.requestStoreReviewByCustomerId(storeId, customerId);
  } catch (e) {
    console.log('ERROR requestStoreReviewByCustomerIdV2', e);
    throw e;
  }
};

export const getReviewsByStoreV2 = async (storeId: string, params: { sortBy: 'desc' | 'asc' | 'newest' | -1 | 1 }) => {
  try {
    return await WashdayClientSingleton.getInstance().review.getList(storeId, params);
  } catch (e) {
    console.log('ERROR getReviewsByStoreV2', e);
    throw e;
  }
};